import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import QtyButton from './QtyButton.jsx'
import CircularProgress from '@mui/material/CircularProgress';

import * as ApiCall from '../ApiCall.jsx';
import { Alert } from '@mui/material';

// footor of dish page, handles adding the given dish to the order in the backend
function AddDishFooter({dishId, extras, instructions}) {

  const navigate = useNavigate();

  const userId = localStorage.getItem('customerId');

  //states [ordering, adding, success]
  //set state = ordering, by default
  const [orderState, setOrderState] = React.useState('ordering');

  
  function handleAddToOrder() {
    //when the button is pressed api cal lto add to stuff to the order backend
    //change to success when suceed with that
    setOrderState('adding');

    //get the current order id    
    ApiCall.get('/customers/orders', 'cId=' + userId)
    .then((orders) => {

      let curOrderId = null;
      for (let i = 0; i < orders.length; i++) {
        if (orders[i].isActive == true) {
          curOrderId = orders[i].id;
        }
      }
      //return the id if there was active dog, else returns null
      return curOrderId;
    })
    .then((curOrderId) => {
      //see if the id is null, if it is, make a new order
      if (curOrderId == null) {
        //make a new order
        return ApiCall.post('/customers/order', 'cId=' + userId)
        .then((order) => {
          curOrderId = order.id;
          return curOrderId;
        })
        .catch((msg) => {alert(msg)})
      }
      //if it is not null, then already have current order, just return it
      else {
        return curOrderId;
      }
    })
    .then((curOrderId) => {
      //now we have an order id
      //post the dish and qty to backend
      ApiCall.post('/order/dish', 'dishId=' + dishId + '&' 
                                + 'orderId=' + curOrderId + '&'
                                + 'quantity=' + qty + '&'
                                + 'customerInstructions=' + instructions())
      .then((newDishId) => {
        //if successful, then we want to add the extras to the order also
        let p = [];
        for (const [k, value] of Object.entries(extras())) {
          if (value.quantity > 0) {
            p.push(
              ApiCall.post("/order/add_extra",  "orderId=" + curOrderId +
                                                "&dishId=" + newDishId + 
                                                "&ingredientId=" + k +
                                                "&quantity=" + value.quantity)
            )
          }
          
        }

        Promise.all(p)
        .then(() => {
          setOrderState('success');
        })
        .catch((msg) => { alert("Failed to send order: " + msg)})
      })
      .catch((msg) => { alert(msg) })
    })
    .catch((msg) => {alert(msg)})
  }

  const [qty, setQty] = React.useState(1);

  function getQty() {
    return qty;
  }


  if (orderState === 'ordering') {
    return (
      <Box sx={{ height: 1/5, width: 1, flexShrink: 0, backgroundColor: 'white', position: 'relative', bottom: 0, 
                  display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
        <QtyButton getQty={getQty} setQty={setQty}></QtyButton>
        <Button variant="contained" sx={{mr: 4, height: 0.4, fontSize: "1.1rem", backgroundColor: "black", textTransform: 'none', ':hover': {
                  color: 'white',
                  bgcolor: 'grey'
                } }} onClick={handleAddToOrder}>Add to order</Button>
      </Box>
    )
  }

  else if (orderState === 'adding') {
    return (
      <Box sx={{ height: 1/5, width: 1, flexShrink: 0, backgroundColor: '#e5e5e5', position: 'relative', bottom: 0, 
                  display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
        <CircularProgress />
      </Box>
    )
  }

  else if (orderState === 'success') {
    return (
      <Box sx={{ height: 1/5, width: 1, flexShrink: 0, backgroundColor: 'white', position: 'relative', bottom: 0,
                  display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', alignItems: 'center'}}>
        {/* <Typography variant="h3">Added!</Typography> */}
        <Button variant="contained" sx={{height: 0.4, fontSize: "1.1rem", backgroundColor: "black", textTransform: 'none', ':hover': {
                  color: 'white',
                  bgcolor: 'grey'
                } }} onClick={() => { navigate("/order") }}>Review and confirm order</Button>
      </Box>
    )
  }
}

export default AddDishFooter;